"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plc_1 = require("../../../plc");
const plcInput_1 = require("../plcInput");
var PlcToggleHold;
(function (PlcToggleHold) {
    PlcToggleHold[PlcToggleHold["toggle"] = 0] = "toggle";
    PlcToggleHold[PlcToggleHold["hold"] = 1] = "hold";
})(PlcToggleHold = exports.PlcToggleHold || (exports.PlcToggleHold = {}));
let PlcButtonComponent = class PlcButtonComponent extends plcInput_1.PlcInput {
    constructor(inaxPlc) {
        super(inaxPlc);
        this._toggle = PlcToggleHold.toggle;
        /* SPECIFIC INPUTS */
        this.trueValue = 'true';
        this.falseValue = 'false';
        this.trueValueMessage = 'Start';
        this.falseValueMessage = 'Stop';
        this.toggleHold = 'toggle';
    }
    get Value() {
        if (this._value === this.trueValue) {
            return this.trueValueMessage;
        }
        else if (this._value === this.falseValue) {
            return this.falseValueMessage;
        }
        else {
            return this._value.toString();
        }
    }
    set Value(v) {
    }
    ngOnInit() {
        this.initializeDefaultProperties();
        this.initialize();
        this.subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    /**
     * sets the enum type this._toggle depending on the string input from @Input() toggleHold
     */
    initialize() {
        this._toggle = (this.toggleHold !== 'toggle') ? PlcToggleHold.hold : PlcToggleHold.toggle;
    }
    /**
     * updates the current value and determines whether it equals the specified trueValue so the button's appearance can be modified depending on it
     * @param value     the value to set
     */
    updateValue(value) {
        this._value = value;
        this.valueTrue = (value === this.trueValue);
    }
    /**
     * writes falseValue if value equals trueValue, else writes trueValue
     */
    switchValue() {
        let val = (this._value === this.trueValue) ? this.falseValue : this.trueValue;
        this.write(val);
    }
    /**
     * handles the clicks on the component's button-element
     * @param isMouseDown   determines whether the mouse-button was pressed or released
     *
     * If the component is set to 'hold', switchValue() is called upon pressing and releasing the mouse-button,
     * if it is set to toggle, switchValue() will only be called upon pressing
     */
    buttonHandler(isMouseDown) {
        // if toggle is off -> change on press and release, always change value, if toggle is on, only change on press
        if (this._toggle === PlcToggleHold.hold || isMouseDown) {
            this.switchValue();
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcButtonComponent.prototype, "trueValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcButtonComponent.prototype, "falseValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcButtonComponent.prototype, "trueValueMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcButtonComponent.prototype, "falseValueMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcButtonComponent.prototype, "toggleHold", void 0);
PlcButtonComponent = __decorate([
    core_1.Component(Object.assign({
        selector: 'plc-button',
        templateUrl: './@inax/plcUi/src/plcButton/plc-button.component.html',
        styleUrls: ['./@inax/plcUi/src/plcButton/plc-button.component.css']
    }, plcInput_1.PlcInput.metaData)),
    __metadata("design:paramtypes", [plc_1.InaxPlcService])
], PlcButtonComponent);
exports.PlcButtonComponent = PlcButtonComponent;
